import React from 'react';
import { Typography } from '@mui/material';
import { WarningBox } from '../Guide.styles';
import { useTranslation } from '../../../i18n';

interface WarningProps {
  children: React.ReactNode;
}

export const Warning: React.FC<WarningProps> = ({ children }) => {
  const { t } = useTranslation();

  return (
    <WarningBox>
      <Typography variant="body2" sx={{ fontWeight: 600, color: '#c62828', mb: 0.5 }}>
        {t('guide.common.important')}
      </Typography>
      <Typography variant="body2" sx={{ color: '#333' }}>
        {children}
      </Typography>
    </WarningBox>
  );
};
